"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchIconRoot = void 0;
var _mui = require("@ori-ui/mui");
const SearchIconRoot = exports.SearchIconRoot = (0, _mui.styled)(_mui.ButtonBase)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'none',
  fontSize: '3rem',
  [theme.breakpoints.down('md')]: {
    display: 'inline-flex'
  }
}));
